var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#support_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M18 15.004a3.748 3.748 0 0 1 7.281 1.249c0 2.498-3.747 3.747-3.747 3.747m.048 5h.017m-.267 8.333c7.825 0 14.167-6.342 14.167-14.166S29.157 5 21.332 5C13.509 5 7.166 11.343 7.166 19.167c0 1.583.26 3.106.739 4.527.18.535.27.803.287 1.008.016.203.004.346-.047.543-.05.2-.163.407-.387.823l-2.726 5.046c-.39.72-.584 1.08-.54 1.357.038.242.18.455.39.583.24.146.646.104 1.46.02l8.535-.882a4 4 0 0 1 .505-.036c.116.005.198.015.31.041.116.027.26.083.55.194 1.58.609 3.296.942 5.09.942"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_svg__a",
    x1: 32.748,
    x2: -27.702,
    y1: 5.782,
    y2: 31.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgSupport;